<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">预约规则设置</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="类型">
          <el-select v-model="formInline.type" clearable filterable placeholder="请选择类型">
            <el-option v-for="item in arules" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="具体场所">
          <el-select v-model="formInline.training_room" filterable clearable placeholder="请选择具体场所">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新建预约规则</el-button>
        </el-form-item>
      </el-form>
    </div>
    <custom-table :data="tableData" ref="table" border style="width: 100%">
      <custom-table-column prop="type_desc" label="类型" width="160">
      </custom-table-column>
      <custom-table-column prop="training_room_name" label="具体场所" width="160">
      </custom-table-column>
      <custom-table-column prop="tqyysj" label="提前预约时间（小时）" width="160">
      </custom-table-column>
      <custom-table-column prop="zdyysc" label="最多预约节次（小时）" width="160">
      </custom-table-column>
      <custom-table-column prop="zmyy" label="周末是否能预约" width="130">
        <template slot-scope="scope">
          <span >{{ scope.row.zmyy?'是':'否' }} </span>
        </template>
      </custom-table-column>
        <custom-table-column prop="can_order_time" label="可预约节次" min-width="235">
        </custom-table-column>
      <!-- <custom-table-column prop="desc" label="备注" min-width="200">
      </custom-table-column> -->
      <custom-table-column fixed="right" label="操作" width="130">
        <template slot-scope="scope">
          <el-button  @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
          <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
        </template>
      </custom-table-column>
    </custom-table>
    <div class="pageLine">
      <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="786px">
      <!-- <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell" @handleOrganQuery="handleOrganQuery">
      </OrganDialog> -->
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
        <el-form-item label="类  型" prop="type">
          <el-select v-model="ruleForm.type" filterable clearable style="width:216px;" placeholder="请选择类型">
            <el-option v-for="item in arules" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="具体场所" prop="training_room_id">
          <el-select v-model="ruleForm.training_room_id" multiple filterable style="width:216px;" placeholder="请选择具体场所" @change="handleClassChange">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提前预约时间" prop="tqyysj">
          <el-input-number v-model="ruleForm.tqyysj" :min="0" placeholder="请输入提前预约时间"
            style="width:200px;"></el-input-number> 天
        </el-form-item>
        <el-form-item label="最多预约节次" prop="zdyysc">
          <el-input-number v-model="ruleForm.zdyysc" :min="0" placeholder="请输入最多预约节次"
            style="width:200px;"></el-input-number> 节
        </el-form-item>
        <el-form-item label="周末是否可以预约" prop="zmyy">
          <el-select v-model="ruleForm.zmyy" filterable clearable style="width:216px;" placeholder="请选择周末是否可以预约">
            <el-option v-for="item in $store.state.iss" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="可预约节次" prop="can_order_time">
          <el-cascader v-model="ruleForm.can_order_time" ref="cascader" :show-all-levels="false" :props="props"
            style="width:564px;" clearable :options="$store.state.sections"></el-cascader>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'" @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinFormatter } from '@/assets/js/mixin/formatter';
// import { mixinOrgan } from '@/assets/js/mixin/organization';

export default {
  name: 'trainingRoom',
  mixins: [mixinList],
  data() {
    return {
      props: {
        label: 'name',
      },
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      props: {
        value: 'label',
        emitPath: false,
        multiple: true
      },
      arules: [{ value: '1', label: '实验实训室' }, { value: '2', label: '场馆' }, { value: '3', label: '会议室' }, { value: '4', label: '图书馆' }],
      formInline: {
        type: '',
        training_room: '',
      },

      formInline1: {},
      levell: [1, 2],
      selectName: '',
      organLabel: '',
      ruleForm: {
        type: '',
        training_room_id: [],
        can_order_time:[],
        tqyysj: '',
        zdyysc: '',
        zmyy: '',
      },
      rules: {
        zmyy: [{ required: true, message: '请选择周末是否可以预约', trigger: 'change' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        training_room_id: [{ required: true, message: '请选择具体场所', trigger: 'change' }],
        can_order_time: [{ required: true, message: '请选择', trigger: 'change' }],
        tqyysj: [{ required: true, message: '请输入', trigger: 'change' }],
        zdyysc: [{ required: true, message: '请输入', trigger: 'change' }],
      },
      fileFieldName: 'annexes',
      innerDialogVisible: false,
      detailDialogVisible: false,
      itemTitle: '',
      typee: 'add',
      tableData1: [],
    };
  },
  created() { },
  mounted() {
    // this.getList();
    // this.$store.dispatch('getStandards');
    this.$store.dispatch('getTarinMent');
    this.$store.dispatch('getSection');
  },
  watch: {
    eqs: {
      handler: function (val) {
        this.ruleForm.special_equipment = val.join(',');
      },
      deep: false,
    },
    safes: {
      handler: function (val) {
        this.ruleForm.safety_facilities = val.join(',');
      },
      deep: false,
    },
  },
  methods: {

    handleClassChange(e) {
      this.ruleForm.training_room = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_name', e);
    },
    resetItemForm(formName) {
      this.$refs[formName].resetFields();
    },

    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/order_room/rule/delete/${params.id}`, 'post', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      params.training_room_id = params.training_room_id.join(',');
      params.can_order_time = params.can_order_time.join(',');
      let res = await this.$api.instance.interfaceServer('api/order_room/rule/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      params.training_room_id = params.training_room_id.join(',');
      params.can_order_time = params.can_order_time.join(',');
      let res = await this.$api.instance.interfaceServer(`api/order_room/rule/edit/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    handleQuery() {
      // this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/order_room/rule/list', 'get', params);
      if (res.code == 0 && res.data) {
        // console.log( this.treeArr)
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

/deep/.el-tag+.el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;

  /deep/ .el-input__inner {
    height: 32px;
    line-height: 32px;
    box-shadow: 0 0 1px 1px #ccc;
    padding: 0 8px;
  }
}</style>
